export default __webpack_public_path__ + "static/media/lalit_sir.c14acdd9.jpg";